export default __webpack_public_path__ + "static/media/bn-blackfriday-gmm.4439046b.jpg";